<template>
  <div class="flex flex-col items-center">
    <component
      :is="require(`@/assets/unitrunk/pictos/${assetUrl}`)"
      width="48px"
    />
    <div class="mt-2  is-size-7 has-text-weight-bold text-primary">
      {{ label }}
    </div>
    <star-rating
      v-if="typeof(score) === 'number'"
      read-only
      :rating="score"
      :show-rating="false"
      :star-size="20"
      active-color="#d19014"
    />
    <div v-else>
      N/C
    </div>
  </div>
</template>

<script>
import StarRating from 'vue-star-rating';

export default {
  name: 'BaseImageWithScore',
  components: { StarRating },
  props: {
    assetUrl: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    score: {
      type: [Number, String],
      required: true,
    },
  },
};
</script>
